<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Makina Düzenle</h4>
              <p class="card-category">Makina özelliklerini düzenleyebilirsiniz. Ürün durumunu değiştirebilirsiniz.</p>
            </template>


            <form class="m-5">
              <div class="row">
                <div class="col-md-5">
                  <base-input type="text" label="Makina Adı (Başlık)" placeholder="Makina Adı" v-model="payload.title">
                  </base-input>
                </div>

                <div class="col-md-5">
                  <label>Kategori Seçimi</label>

                  <select class="form-control" v-model="payload.category">
                    <option value="-1">Makina Kategorisi Seçiniz</option>
                    <option v-for="category in categories" :key="category._id" :value="category._id">
                      {{ category.name }}
                    </option>
                  </select>
                </div>

                <div class="col-md-1">
                  <label>Kur</label>

                  <select class="form-control" v-model="payload.currency">
                    <option value="">Fiyat Kurunu Seçiniz</option>
                    <option v-for="currency in currencies" :key="currency._id" :value="currency._id">
                      {{ currency.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-1">
                  <base-input type="number" min="0" label="Fiyat" placeholder="Fiyat" v-model="payload.price">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Marka" placeholder="Marka" v-model="payload.brand">
                  </base-input>
                </div>
                <div class="col-md-4">
                  <base-input type="text" label="Model İsmi" placeholder="Model İsmi" v-model="payload.modelName">
                  </base-input>
                </div>
                <div class="col-md-4">
                  <base-input type="number" label="Model Yılı" placeholder="Model Yılı" v-model="payload.modelYear">
                  </base-input>
                </div>
              </div>

              <label>Makina Açıklaması</label>
              <div class="row">
                <div class="col-md-12">
                  <textarea class="form-control" :rows="payload.description.split('\n').length" label="Açıklama"
                    placeholder="Ürün açıklaması giriniz" v-model="payload.description">
      </textarea>
                </div>
              </div>

              <label>Makinanın Lokasyonu</label>
              <div class="row">
                <div class="col-md-2">
                  <base-input type="text" label="Ülke" placeholder="Ülke" v-model="payload.country">
                  </base-input>
                </div>

                <div class="col-md-2">
                  <base-input type="text" label="Şehir" placeholder="Şehir" v-model="payload.city">
                  </base-input>
                </div>


                <div class="col-md-8">
                  <textarea class="form-control mt-4" :rows="payload.address ? payload.address.split('\n').length : 1"
                    label="Açık Adres" placeholder="Ürün açık adresi giriniz" v-model="payload.address">
      </textarea>
                </div>
              </div>


              <div class="row pt-5">
                <div class="col-md-4">
                  <label>Aktif Mi?</label>
                  <base-checkbox type="text" label="Aktif" placeholder="Aktif" v-model="payload.isActive"
                    :checked="payload.isActive" @click="payload.isActive = !payload.isActive">
                  </base-checkbox>
                </div>
                <div class="col-md-5">
                  <label>Durum Seçimi</label>


                  <select class="form-control" v-model="payload.status">
                    <option value="-1">Durum Seçiniz</option>
                    <option v-for="status in statusMap" :key="status._id" :value="status._id">
                      {{ status.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3">

                  <base-input type="text" label="Sitede Kaçıncı Sırada Gözüksün?"
                    placeholder="Sitede Kaçıncı Sırada Gözüksün?" v-model="payload.websiteListIndex">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <label>Makina Özellikleri</label>
                  <div v-for="(attribute, index) in payload.attributes" :key="index" class="d-flex mb-2">
                    <input type="text" class="form-control mr-2" v-model="attribute.key" placeholder="Özellik">
                    <input type="text" class="form-control mr-2" v-model="attribute.value" placeholder="Değer">
                    <input type="text" class="form-control mr-2" v-model="attribute.unit" placeholder="Birim">
                    <button class="btn btn-danger btn-sm btn-fill" @click="removeAttribute(index)">Sil</button>
                  </div>
                  <div class="mt-2">

                    <button class="btn btn-sm btn-primary" @click="addAttribute()">Yeni Özellik Ekle</button>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <label>Makinaya Ait Resimler</label>
                  <div class="custom-file mb-3">
                    <input type="file" class="custom-file-input" id="customFile" multiple accept="image/*"
                      @change="handleFileUpload" ref="fileInput">
                    <label class="custom-file-label" for="customFile">Yüklenecek Resmi Seçiniz</label>
                  </div>
                  <div class="d-flex flex-wrap">
                    <div v-for="(preview, index) in payload.images" :key="index" class="position-relative mr-3 mb-3">
                      <img :src="preview.url" class="img-thumbnail" :alt="preview.alt"
                        style="width: 250px; height: 250px; object-fit: cover;">
                      <button class="btn btn-danger btn-sm d-block mx-auto mt-2 btn-fill text-white font-weight-bold"
                        @click="removeImage(index)">
                        <i class="nc-icon nc-simple-remove font-weight-bold"></i>
                      </button>
                      <span class="badge badge-primary position-absolute w-5 h-5" style="top: 10px; right: 10px;">{{
                        index
                        + 1 }} </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <label>Makinaya Ait Videolar</label>
                  <div v-for="(video, index) in payload.videos" :key="index" class="d-flex mb-2">
                    <input type="text" class="form-control mr-2" v-model="video.url" placeholder="Video URL">
                    <button class="btn btn-danger btn-sm btn-fill" @click="removeVideo(index)">Sil</button>
                  </div>
                  <div class="mt-2">

                    <button class="btn btn-sm btn-primary" @click="addVideo()">Yeni Video Ekle</button>
                  </div>
                </div>
              </div>








              <div class="text-center pt-5">
                <button type="submit" class="btn btn-info btn-fill float-right" @click="updateItem()">
                  Güncelle
                </button>
              </div>
              <div class="clearfix"></div>
            </form>


          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      payload: {
        title: "",
        brand: "",
        modelName: "",
        modelYear: "",
        description: "",
        price: 0,
        currency: "EUR",
        category: "-1",
        isActive: true,
        status: '-1',
        attributes: [],
        images: [],
        videos: [],
        country: "",
        city: "",
        address: ""
      },
      categories: [],
      currencies: [{
        _id: "EUR",
        name: "Euro"
      }, {
        _id: "USD",
        name: "Dolar"
      }, {
        _id: "TRY",
        name: "Türk Lirası"
      }
      ],
      statusMap: [
        {
          _id: "active",
          name: "Listede"
        },
        {
          _id: "inactive",
          name: "Pasif"
        },
        {
          _id: "sold",
          name: "Satıldı"
        },
        {
          _id: "pending",
          name: "Beklemede"
        },
        {
          _id: "rented",
          name: "Kiralandı"
        },
        {
          _id: "maintenance",
          name: "Tamirde"
        },
        {
          _id: "other",
          name: "Diğer"
        }
      ],
      countries: [],
      cities: [],
      websiteListIndex: null
    }
  },
  mounted() {
    this.getCategories();
    this.getItem();
    this.getCountries();
  },
  methods: {
    updateItem() {
      let payload = { ...this.payload };

      payload.price = Number(payload.price);
      payload.modelYear = Number(payload.modelYear);

      CollectionService.updateCollectionItem('item', this.id, payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Makina Güncellendi")
          this.$router.push(`/admin/items`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    getCategories() {

      let q = {};
      let p = {};
      let o = { skip: 0, limit: 1000 }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('category', query).then((res) => {
        if (res.success == true) {
          this.categories = res.categories;
        } else {
          console.log('error');
        }
      })
    },
    getItem() {
      this.id = window.location.href.split('/').at(-1);
      CollectionService.getCollectionItemWithId('item', this.id).then((res) => {
        if (res.success == true) {
          this.payload = res.item;
        }
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    addAttribute() {
      this.payload.attributes.push({
        key: "",
        value: "",
        unit: ""
      })
    },
    removeAttribute(index) {
      this.payload.attributes.splice(index, 1);
    },
    removeImage(index) {
      this.payload.images.splice(index, 1);
    },
    handleFileUpload(e) {
      const files = e.target.files;
      if (!files || files.length === 0) return;

      const file = files[0];

      const formData = new FormData();
      formData.append('file', file, file.name);

      CollectionService.uploadFile(formData)
        .then((res) => {
          if (res.success) {
            if (this.payload.images.length == 0) {
              this.payload.images.push({ url: res.data.url, alt: file.name, order: 0, isPrimary: true });
            } else {
              this.payload.images.push({ url: res.data.url, alt: file.name, order: this.payload.images.length, isPrimary: false });
            }

            this.notifyVue('bottom', 'right', 'success', 'Image uploaded successfully');
          } else {
            this.notifyVue('bottom', 'right', 'danger', 'Failed to upload image');
          }
        })
        .catch(err => {
          this.notifyVue('bottom', 'right', 'danger', 'Error uploading image');
          console.error(err);
        });
    },
    getCountries() {
      fetch('https://restcountries.com/v3.1/all')
        .then(response => response.json())
        .then(data => {
          this.countries = data.map(country => ({
            _id: country.cca3,
            name: country.name.common
          })).sort((a, b) => a.name.localeCompare(b.name));
        })
        .catch(error => {
          console.error('Error fetching countries:', error);
          this.notifyVue('bottom', 'right', 'danger', 'Error loading countries list');
        });
    },
    addVideo() {
      this.payload.videos.push({ url: "", order: this.payload.videos.length, isPrimary: this.payload.videos.length == 0 ? true : false, alt: "" });
    },
    removeVideo(index) {
      this.payload.videos.splice(index, 1);
    }
  }
}
</script>
<style></style>